module.exports = __webpack_public_path__ + "img/clouds.187529d9.svg";